import { defineMessages } from "react-intl";

export default defineMessages({
  getASubscriptionAndSaveXInServiceFees: {
    id: "serviceFeeSubcriptionCTA.getASubscriptionAndSaveXInServiceFees",
    defaultMessage:
      "Get <bold>Ring Twice +</bold> and <bold>save {serviceFee}</bold> in service fees",
  },
});
